import { ADMIN_LEVEL_USE_MOCK } from "../config/admin.config";
import { levelApiHttp } from "./levelApi.http";
import { levelApiMock } from "./levelApi.mock";

export const levelApi = ADMIN_LEVEL_USE_MOCK ? levelApiMock : levelApiHttp;
